import React from 'react';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// @material-ui/icons

// core components
import Header from 'components/Header/Header.jsx';
import Button from 'components/CustomButtons/Button.jsx';

import headersStyle from 'assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.jsx';

function SectionHeaders({ ...props }) {
  const { classes } = props;

  const scrollTo = elemId => {
    const element_to_scroll_to = document.getElementById(elemId);
    element_to_scroll_to.scrollIntoView();
  };
  return (
    <Header
      absolute
      fixed
      brand="Erin Yoga Studio"
      color="white"
      links={
        <div className={classes.collapse}>
          <List className={classes.list + ' ' + classes.mlAuto}>
            <ListItem className={classes.listItem}>
              <Button
                href="#"
                className={classes.navLink}
                onClick={e => {
                  e.preventDefault();
                  scrollTo('aboutUs');
                }}
                color="transparent"
              >
                About Me
              </Button>
            </ListItem>
            {/* <ListItem className={classes.listItem}>
              <Button
                href="#pablo"
                className={classes.navLink}
                onClick={e => e.preventDefault()}
                color="transparent"
              >
                Gallery
              </Button>
            </ListItem> */}
            <ListItem className={classes.listItem}>
              <Button
                href="#"
                className={classes.navLink}
                onClick={e => {
                  e.preventDefault();
                  scrollTo('programmes');
                }}
                color="transparent"
              >
                Programmes
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                href="#"
                className={classes.navLink}
                onClick={e => {
                  e.preventDefault();
                  scrollTo('specialEvents');
                }}
                color="transparent"
              >
                Special Events
              </Button>
            </ListItem>
          </List>
          <List className={classes.list + ' ' + classes.mlAuto}>
            <ListItem className={classes.listItem}>
              <Button
                color="transparent"
                href="https://www.youtube.com/channel/UCYSuigDznRM0ci5JQ2PVYBg/"
                target="_blank"
                className={`${classes.navLink} ${classes.navLinkJustIcon}`}
              >
                <i className={'fab fa-youtube'} />
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                color="transparent"
                href="https://www.facebook.com/irina.galka.5"
                target="_blank"
                className={`${classes.navLink} ${classes.navLinkJustIcon}`}
              >
                <i className={'fab fa-facebook'} />
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                color="transparent"
                href="https://www.instagram.com/erin_yoga_studio/"
                target="_blank"
                className={`${classes.navLink} ${classes.navLinkJustIcon}`}
              >
                <i className={'fab fa-instagram'} />
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                color="transparent"
                href="mailto:erinyogastudio@gmail.com"
                target="_blank"
                className={`${classes.navLink} ${classes.navLinkJustIcon}`}
              >
                <i className="fas fa-envelope-square" />
              </Button>
            </ListItem>
          </List>
        </div>
      }
    />
  );
}

export default withStyles(headersStyle)(SectionHeaders);



// WEBPACK FOOTER //
// ./src/views/YogaPage/YogaHeader.jsx